(() => {
  document.querySelectorAll('[data-collection-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('[data-product-card]').forEach(card => {
    const data = card.querySelector('[data-card-variant-json]');
    if (!data || card.dataset.swatchesInitialized) return;
    card.dataset.swatchesInitialized = 'true';
    const parsed = JSON.parse(data.textContent);
    const variants = Array.isArray(parsed) ? parsed : [];
    const swatches = [...card.querySelectorAll('[data-card-variant]')];
    const group = card.querySelector('.card-swatches');
    const options = card.querySelector('.card-swatches__options');
    const toggle = card.querySelector('[data-card-swatches-toggle]');
    const updateVisibleSwatches = () => {
      const expanded = toggle?.getAttribute('aria-expanded') === 'true';
      const selectedIndex = swatches.findIndex(swatch => swatch.getAttribute('aria-pressed') === 'true');
      // Keep an already-selected later shade visible when collapsing without changing its variant.
      swatches.forEach((swatch, index) => {
        swatch.hidden = !expanded && index >= (selectedIndex > 3 ? 3 : 4) && index !== selectedIndex;
      });
      group?.classList.toggle('card-swatches--expanded', expanded);
      if (options) options.scrollLeft = 0;
    };
    toggle?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      const expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', expanded ? 'Show fewer colors' : 'Show more colors');
      toggle.firstElementChild.textContent = expanded ? '−' : '+';
      updateVisibleSwatches();
      if (expanded) {
        const selected = swatches.find(swatch => swatch.getAttribute('aria-pressed') === 'true');
        if (selected && options) options.scrollLeft = Math.max(0, selected.offsetLeft - options.clientWidth / 2);
      }
    });
    updateVisibleSwatches();
    card.querySelectorAll('[data-card-variant]').forEach(button => button.addEventListener('click', () => {
      const variant = variants.find(item => String(item.id) === button.dataset.cardVariant);
      if (!variant) return;
      card.querySelectorAll('[data-card-variant]').forEach(swatch => swatch.setAttribute('aria-pressed', String(swatch === button)));
      const image = card.querySelector('.product-card__media img');
      // A null featured-media association is retained; never infer a variant image from filenames.
      const displayedImage = variant.image || card.dataset.cardFallbackImage;
      if (image && displayedImage) { image.src = displayedImage; image.removeAttribute('srcset'); }
      // Liquid prices are cents; divide once, preserving native compare-at arithmetic.
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: card.dataset.cardCurrency || 'USD' }).format(Number(amount) / 100);
      const discounted = Number(variant.compare_at_price) > Number(variant.price) && Number(variant.compare_at_price) > 0;
      card.querySelector('[data-card-price]').textContent = money(variant.price);
      const compare = card.querySelector('[data-card-compare]'); compare.hidden = !discounted; compare.textContent = discounted ? money(variant.compare_at_price) : '';
      const badge = card.querySelector('[data-card-badge]'); badge.hidden = !discounted; badge.textContent = discounted ? `-${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%` : '';
      const legacy = card.querySelector('[data-card-legacy]'); if (legacy) legacy.hidden = discounted;
      const link = card.querySelector('[data-card-url]'); const url = new URL(link.href); url.searchParams.set('variant', variant.id); link.href = url.href;
    }));
  });
})();
